import { Button } from "@/components/ui/button";
import { useCategories } from "@/hooks/useCategories";
import { Dog, Cat, Bird } from "lucide-react";

interface ProductFiltersProps {
  selectedCategory: string;
  selectedPetType: string;
  onCategoryChange: (category: string) => void;
  onPetTypeChange: (petType: string) => void;
}

const ProductFilters = ({ 
  selectedCategory, 
  selectedPetType,
  onCategoryChange,
  onPetTypeChange 
}: ProductFiltersProps) => {
  const { data: categories = [], isLoading } = useCategories();

  return (
    <div className="space-y-6 mb-8">
      {/* Pet Type Filters */}
      <div>
        <h3 className="text-sm font-semibold mb-3 text-muted-foreground">Tipo de Mascota</h3>
        <div className="flex flex-wrap gap-3">
          <Button
            variant={selectedPetType === "all" ? "default" : "outline"}
            size="sm"
            onClick={() => onPetTypeChange("all")}
            className="transition-all"
          >
            Todos
          </Button>
          <Button
            variant={selectedPetType === "dog" ? "default" : "outline"}
            size="sm"
            onClick={() => onPetTypeChange("dog")}
            className="transition-all"
          >
            <Dog className="h-4 w-4 mr-2" />
            Perros
          </Button>
          <Button
            variant={selectedPetType === "cat" ? "default" : "outline"}
            size="sm"
            onClick={() => onPetTypeChange("cat")}
            className="transition-all"
          >
            <Cat className="h-4 w-4 mr-2" />
            Gatos
          </Button>
          <Button
            variant={selectedPetType === "other" ? "default" : "outline"}
            size="sm"
            onClick={() => onPetTypeChange("other")}
            className="transition-all"
          >
            <Bird className="h-4 w-4 mr-2" />
            Otros
          </Button>
        </div>
      </div>

      {/* Category Filters */}
      <div>
        <h3 className="text-sm font-semibold mb-3 text-muted-foreground">Categoría</h3>
        {isLoading ? (
          <p className="text-muted-foreground text-sm">Cargando categorías...</p>
        ) : (
          <div className="flex flex-wrap gap-3">
            {categories.map((category) => (
              <Button
                key={category.id}
                variant={selectedCategory === category.slug ? "default" : "outline"}
                size="sm"
                onClick={() => onCategoryChange(category.slug)}
                className="transition-all"
              >
                {category.name}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductFilters;
